import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import axios from '@services/api/axiosConfig';

import Project from '@models/project/Project';
import Configuration from '@models/project/Configuration';
import Contact from '@models/project/Contact';

import Building from '@models/building/Building';
import Unit from '@models/building/Unit';
import Room from '@models/building/Room';

import Roomtype from '@models/helpers/Roomtype'
import RoomtypeAt from '@models/helpers/RoomtypeAt'
import LtmHasRoomtype from '@models/helpers/LtmHasRoomtype'
import LtmHasRoomtypeAt from '@models/helpers/LtmHasRoomtypeAt'
import Ltm from '@models/helpers/Ltm'
import LtmAt from '@models/helpers/LtmAt'
import LtmHasRoomtypeHasRoomltm from '@models/helpers/LtmHasRoomtypeHasRoomltm'
import LtmHasRoomtypeHasRoomltmAt from '@models/helpers/LtmHasRoomtypeHasRoomltmAt'
import Roomltm from '@models/helpers/Roomltm'
import RoomltmAt from '@models/helpers/RoomltmAt'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'
import RoomtypesHasOperationmodesHasAirvolumeAt from '@models/helpers/RoomtypesHasOperationmodesHasAirvolumeAt'
import Operationmode from '@models/helpers/Operationmode'
import OperationmodeAt from '@models/helpers/OperationmodeAt'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmode'
import RoomltmsHasOperationmodeAt from '@models/helpers/RoomltmsHasOperationmodeAt'
import RoomtypesHasLtmsHasOperationmodesHasDevicepackage
  from '@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackage'
import RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt
  from '@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt'

import Article from '@models/helpers/Article';
import ArticleHasFeature from '@models/helpers/ArticleHasFeature';
import Feature from '@models/helpers/Feature';
import Accessorygroup from '@models/helpers/Accessorygroup';
import ArticlesHasAccessorygroup from '@models/helpers/ArticlesHasAccessorygroup';
import DevicepackagesHasArticle from '@models/helpers/DevicepackagesHasArticle';
import ArticleHasChild from '@models/helpers/ArticleHasChild';
import Articledetail from '@models/helpers/Articledetail';
import File from '@models/helpers/File';
import Countryprice from '@models/helpers/Countryprice';
import Rule from '@models/helpers/Rule';
import Documentfile from '@models/helpers/Documentfile';

import Unitairvolume from '@models/airvolumes/Unitairvolume'
import Roomairvolume from '@models/airvolumes/Roomairvolume'
import Systemselection from '@models/airvolumes/Systemselection'
import Installation from '@models/airvolumes/Installation'
import Valve from '@models/airvolumes/Valve'

import StoredRoomArticle from '@models/articles/StoredRoomArticle'
import StoredArticle from '@models/articles/StoredArticle'

import UserArticle from '@models/helpers/UserArticle';
import SelectedUserArticle from '@models/articles/SelectedUserArticle';

VuexORM.use(VuexORMAxios, {axios})
const database = new VuexORM.Database();

database.register(Project)
database.register(Configuration)
database.register(Contact)

database.register(Building)
database.register(Unit)
database.register(Room)

database.register(Roomtype)
database.register(RoomtypeAt)
database.register(LtmHasRoomtype)
database.register(LtmHasRoomtypeAt)
database.register(Ltm)
database.register(LtmAt)
database.register(LtmHasRoomtypeHasRoomltm)
database.register(LtmHasRoomtypeHasRoomltmAt)
database.register(Roomltm)
database.register(RoomltmAt)
database.register(RoomtypesHasOperationmodesHasAirvolume)
database.register(RoomtypesHasOperationmodesHasAirvolumeAt)
database.register(Operationmode)
database.register(OperationmodeAt)
database.register(RoomltmsHasOperationmode)
database.register(RoomltmsHasOperationmodeAt)
database.register(Accessorygroup)
database.register(ArticleHasFeature)
database.register(Article)
database.register(ArticlesHasAccessorygroup)
database.register(DevicepackagesHasArticle)
database.register(Feature)
database.register(ArticleHasChild)
database.register(RoomtypesHasLtmsHasOperationmodesHasDevicepackage)
database.register(RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt)
database.register(Articledetail)
database.register(File)
database.register(Countryprice)
database.register(Rule)
database.register(Documentfile)

database.register(Unitairvolume)
database.register(Roomairvolume)
database.register(Systemselection)
database.register(Installation)
database.register(Valve)

database.register(StoredArticle)
database.register(StoredRoomArticle)

database.register(UserArticle)
database.register(SelectedUserArticle)

export default database;
